module.exports = __webpack_public_path__ + "img/jenks-pro.72570339.jpg";